import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-142bcb14"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-ter btn line--only title-item" }
const _hoisted_2 = { class: "abs dropdown-menu" }
const _hoisted_3 = ["onClick"]

import { t } from '@/plugins/i18n'
import { ref, computed } from 'vue'
import { bury } from '@/util/useBury'

interface I {
  value: string | number
  label: string
}

export default /*#__PURE__*/_defineComponent({
  props: ['modelValue', 'options', 'itemkey'],
  emits: ['update:modelValue'],
  setup(__props, { emit }) {

const props = __props



const hover = ref(false)

const item = computed(() => {
  return props.options.find((v: I) => v.value === props.modelValue) || {}
})

const handleClick = (v: I) => {
  if (v.label) {
    bury('ALL_Click_ChannelChose2')
  }
  emit('update:modelValue', v.value)
  hover.value = false
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["dropdown cate-dropdown", { active: hover.value }]),
    onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (hover.value = true)),
    onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (hover.value = false))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps(_unref(item))), () => [
        _createElementVNode("div", null, _toDisplayString(_unref(t)(_unref(item).label)), 1)
      ]),
      _createElementVNode("i", {
        style: _normalizeStyle({ transform: `scaleY(${hover.value ? -1 : 1})` }),
        class: "ml_5 fa fa-caret-down"
      }, null, 4)
    ]),
    _createVNode(_Transition, { name: "el-zoom-in-top" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (v) => {
            return (_openBlock(), _createElementBlock("div", {
              key: v.label
            }, [
              _renderSlot(_ctx.$slots, "item", _normalizeProps(_guardReactiveProps(v)), () => [
                _createElementVNode("div", {
                  class: "btn option-item",
                  onClick: ($event: any) => (handleClick(v))
                }, _toDisplayString(_unref(t)(v.label)), 9, _hoisted_3)
              ])
            ]))
          }), 128))
        ], 512), [
          [_vShow, hover.value]
        ])
      ]),
      _: 3
    })
  ], 34))
}
}

})